<template>
  <div class="joinRequest">
    <user-photo
      class="user-photo"
      :user="ownerRequest.owner"
    />
    <div class="name">
      <span>{{ ownerRequest.owner.firstName }} {{ ownerRequest.owner.lastName }}</span>
    </div>
    <img
      @click="decline(ownerRequest)"
      src="@/assets/Decline.svg"
    />
    <img
      @click="approve(ownerRequest)"
      src="@/assets/Accept.svg"
    />
  </div>
</template>

<script>
import UserPhoto from '@/components/shared/UserPhoto'

export default {
  name: 'ValidOwnerRequest',
  components: { UserPhoto },
  props: {
    ownerRequest: {
      type: Object,
      required: true
    }
  },
  methods: {
    approve (ownerRequest) {
      this.$store.dispatch('approveOwnerRequest', ownerRequest)
    },
    decline (ownerRequest) {
      this.$store.dispatch('declineOwnerRequest', ownerRequest)
    }
  }
}

</script>

<style scoped lang="scss">

.joinRequest {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 17px 5px 7px;
  .user-photo {
    height: 3rem;
    border-radius: 100%;
  }
  .name {
    width:8rem;
    display: flex;
    font-size: 14px;
    text-align: left;
  }
  img {
    cursor: pointer;
    color: $primary-color;
    &:hover {
      text-decoration: underline;
    }
  }
}

</style>
